import { render, staticRenderFns } from "./DiagnoseResultLayout.vue?vue&type=template&id=b82dea5a&scoped=true"
import script from "./DiagnoseResultLayout.vue?vue&type=script&lang=js"
export * from "./DiagnoseResultLayout.vue?vue&type=script&lang=js"
import style0 from "./DiagnoseResultLayout.vue?vue&type=style&index=0&id=b82dea5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82dea5a",
  null
  
)

export default component.exports